// @ts-expect-error type DraggableProvider
import DraggableProvider from '../../context/DraggableProvider';
import UnconnectedSortableList from '../unconnected/UISortableList';
import { jsx as _jsx } from "react/jsx-runtime";
const UISortableList = props => {
  return /*#__PURE__*/_jsx(DraggableProvider, {
    children: /*#__PURE__*/_jsx(UnconnectedSortableList, Object.assign({}, props))
  });
};
export default UISortableList;